import React, { Component } from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { translate } from 'react-i18next';
import { defaultScale } from '../../utils/scaling';
export class ShoppingListHeader extends Component {
    render() {
        const { t ,numberOfSelectedMeals} = this.props;
        return (
            <View style={styles.container}>
                <View style={styles.mealCountContainer}>
                    <Text style={styles.headerText}>{t('numberOfMeals', { numberOfSelectedMeals })}</Text>
                    <Text style={styles.subHeader}>{t('onShoppingList')}</Text>
                </View>
                <View style={styles.buttonContainer}>
                    <Button
                        title={t('editList')}
                        onPress={this.props.toggleModal}
                        buttonType={ButtonTypes.TRANSPARENT}
                        overrideFontStyles={styles.buttonTextStyle}
                    />
                </View>
               
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        borderBottomWidth: 1,
        borderBottomColor: Theme.GREY_LIGHT,
        backgroundColor:Theme.WHITE,
    },
    buttonContainer: {
        width: '20%',
        margin: defaultScale(10),
    },
    mealCountContainer: {
        width: '70%',
        alignContent: 'center',
        justifyContent: 'center',
        paddingHorizontal: defaultScale(10),
    },
    headerText: {
        ...Theme.textStyle.bodyCopyBold,
    },
    subHeader: {
        ...Theme.textStyle.bodyCopyReg
    },
    buttonTextStyle:{
        ...Theme.textStyle.bodyCopyBold,
    }
});

export default translate(['nutrition'], { wait: true })(ShoppingListHeader);
